//export const API_URL = 'https://api.plastik.teko-dev.com/api/';
export const API_URL = window.location.hostname == 'localhost' ? 'http://www.plastik-api.com.mx:8084/api/' : 'https://api.plastik.teko-dev.com/api/';
export const APP_URL = window.location.hostname == 'localhost' ? 'localhost:8080/' : 'http://www.plastik-api.com.mx:8084';
export const APP_PREFIX = 'plastik';

export const USER_ROLES = [
    { role: 'administrador', label: 'Administrador' },
    { role: 'coordinador', label: 'Coordinador' },
    { role: 'supervisor', label: 'Supervisor' }
];